import { Map, List } from 'immutable'
import {
  SORT_TYPE_CONTENT_ID,
  SORT_TYPE_CONTENT_PUBLISHED_AT_DATE,
} from 'services/content/sort-types'

export default List([
  Map({ label: 'Please select a sort type', value: '' }),
  Map({ label: 'Content ID', value: SORT_TYPE_CONTENT_ID }),
  Map({ label: 'Published at date', value: SORT_TYPE_CONTENT_PUBLISHED_AT_DATE }),
])
